import { GetWcClaimInput, GetWcClaimCommand } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function getWcClaimService(input: GetWcClaimInput) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return null;
  }
  const command = new GetWcClaimCommand(input);
  const metricsPublisher = new MetricsPublisher("api.getWcClaimService");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      return error;
    });
}
